import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    ProvisionPhoneNumber,
    ProvisionPhoneNumberVariables,
    PhoneNumberProvisionInput,
} from 'nutshell-graphql-types';

import PROVISION_PHONE_NUMBER from '../mutations/provision-phone-number.graphql';
import GET_INBOX_STATUS from '../queries/get-inbox-status.graphql';

export function useProvisionPhoneNumber(): {
    provisionPhoneNumber: (arg1: PhoneNumberProvisionInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [provisionPhoneNumber, {loading: isLoading, error}] = useMutation<
        ProvisionPhoneNumber,
        ProvisionPhoneNumberVariables
    >(PROVISION_PHONE_NUMBER);

    return {
        provisionPhoneNumber: (input: PhoneNumberProvisionInput) =>
            provisionPhoneNumber({
                variables: {input},
                update: (cache, {data}) => {
                    const newNutshellChannel =
                        data && data.phoneNumberProvision && data.phoneNumberProvision.inboxChannel;

                    const cacheResult = cache.readQuery({
                        query: GET_INBOX_STATUS,
                    });

                    if (newNutshellChannel && cacheResult) {
                        cache.writeQuery({
                            query: GET_INBOX_STATUS,
                            data: {
                                ...cacheResult,
                                inboxStatus: {
                                    // @ts-expect-error
                                    ...cacheResult.inboxStatus,
                                    phoneStatus: {
                                        status: 'VALID',
                                        nutshellChannel: newNutshellChannel,
                                    },
                                },
                            },
                        });
                    }
                },
            }),
        isLoading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
